module.exports = __webpack_public_path__ + "img/Facilitator test Learning Lab.bea3287b.png";